<script lang="ts">
  import CartWidgetInputV2 from "@retailer/svelte/CartWidget/v2/CartWidgetInputV2.svelte";
  import CartWidgetButtonV2 from "@retailer/svelte/CartWidget/v2/CartWidgetButtonV2.svelte";
  import CartWidgetLabelV2 from "@retailer/svelte/CartWidget/v2/CartWidgetLabelV2.svelte";
  import * as pluralize from "@shared/svelte/Modules/pluralize";
  import { createEventDispatcher } from "svelte";

  import type {
    BuyingOption,
    StockLevels,
  } from "@retailer/svelte/CartWidget/v2/Services/CartItemRequestService";

  export let inventoryId: number;
  export let containerType: string;
  export let disabled: boolean;
  export let option: BuyingOption;
  export let disableIncrement: boolean;
  export let stockLevel: StockLevels;

  const dispatch = createEventDispatcher();

  const add = () => {
    const oldQuantity = quantity;
    quantity++;

    dispatch("updateQuantity", {
      trackingAction: "add",
      newQuantity: quantity,
      oldQuantity: oldQuantity,
      quantityType: option.quantity_type,
      stockLevel: stockLevel,
      eventName: "cart_add",
    });
  };

  const subtract = () => {
    const oldQuantity = quantity;

    if (quantity >= 1) {
      quantity--;
    }
    dispatch("updateQuantity", {
      trackingAction: "remove",
      oldQuantity: oldQuantity,
      newQuantity: quantity,
      quantityType: option.quantity_type,
      stockLevel: stockLevel,
      eventName: "cart_remove",
    });
  };

  const inputUpdate = (event: CustomEvent) => {
    const oldQuantity = quantity;
    quantity = event.detail.newQuantity;

    dispatch("updateQuantity", {
      trackingAction: "set",
      newQuantity: quantity,
      oldQuantity: oldQuantity,
      quantityType: option.quantity_type,
      eventName: oldQuantity > quantity ? "cart_remove" : "cart_add",
      stockLevel: stockLevel,
    });
  };

  $: label = option.label;
  $: quantity = option.quantity;
</script>

<style>
  .cart-widget-wrapper {
    background: #f5f7f7;
    color: #0f1924;
    height: 44px;
  }
</style>

<div
  class="cart-widget-wrapper fizz-text-medium fizz-inset-square-4 fizz-radius-medium fizz-bordered fizz-flex-row fizz-space-between"
>
  <div class="fizz-flex-row-8 fizz-flex-justify-start fizz-text-center fizz-text-small">
    <CartWidgetInputV2
      {inventoryId}
      {disabled}
      {quantity}
      {disableIncrement}
      on:inputQuantityChange={inputUpdate}
      containerType={pluralize.singular(label)}
    />
    <CartWidgetLabelV2 {containerType} {inventoryId} {label} />
  </div>
  <div class="fizz-justify-end fizz-flex-row-8 fizz-text-strong fizz-text-large">
    <CartWidgetButtonV2
      actionType="decrement"
      {containerType}
      {disabled}
      {inventoryId}
      on:decrement={subtract}
    />
    <CartWidgetButtonV2
      actionType="increment"
      {containerType}
      disabled={disabled || disableIncrement}
      {inventoryId}
      on:increment={add}
    />
  </div>
</div>
